import React from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import Button from './button';

import { Grid, Row, Col } from './grid-system';
import bp from '../assets/js/breakpoints';

gsap.registerPlugin(ScrollToPlugin);

const FooterWrapper = styled.footer`
  padding: var(--space-m) 0;

  @media (${bp.min.xs_sm}) {
    padding: var(--space-l) 0;
  }
`;

const EyeLogoWrapper = styled.button`
  margin: 0 auto;
  cursor: pointer;
  width: 7.2rem;
  margin-top: var(--space-xxxs);
  padding: 0;

  @media (${bp.min.xs}) {
    width: 9.2rem;
    /* margin-right: var(--space-m); */
  }

  @media (${bp.min.xs_sm}) {
    width: auto;
    display: block;
    margin-top: 0;
  }

  &:hover {
    path:nth-of-type(2) {
      fill: var(--c-blue);
    }
  }

  &:focus {
    outline: none;
  }

  svg {
    max-width: 100%;
    fill: var(--c-white);

    path:nth-of-type(2) {
      transition: all 300ms var(--easeInOutExpo);
    }
  }
`;

const Copyright = styled.div`
  span {
    line-height: 1.2;
    color: var(--c-gray);
  }
`;

const EyeLogo = () => {
  const scrollTop = () => {
    gsap.to(window, { scrollTo: 0, duration: 2, ease: 'cubic.inOut' });
  };

  return (
    <EyeLogoWrapper onClick={scrollTop} aria-label="Back to top">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="104"
        height="28"
        viewBox="0 0 104 28"
      >
        <path
          d="M6.48189507,0.656192416 L6.48189507,14.2532816 L8.21755314,14.2169377 C12.6452096,14.2169377 14.8058412,12.3212023 14.8058412,7.32714831 C14.8058412,2.84344914 12.6805243,0.656192416 8.60706241,0.656192416 L6.48189507,0.656192416 Z M6.48189507,14.8729761 L6.48189507,22.9655026 L9.13842906,24.3873811 L9.13842906,24.6060606 L0.0706294173,24.6060606 L0.0706294173,24.3873811 L2.6918487,22.9655026 L2.6918487,1.74989778 L1.59872116e-14,0.218833472 L1.59872116e-14,1.24344979e-14 L9.28013681,1.24344979e-14 C14.8767699,1.24344979e-14 18.6666667,1.89573542 18.6666667,6.85329146 C18.6666667,10.9724735 15.6559381,14.8729761 8.71345545,14.8729761 L6.48189507,14.8729761 Z"
          transform="translate(84.849 1.697)"
        />
        <path
          d="M14.9979075,13.6655913 C14.9979075,10.2202091 17.8191387,7.41737159 21.2869434,7.41737159 C24.7547481,7.41737159 27.5759792,10.2202091 27.5759792,13.6655913 C27.5759792,17.1109736 24.7547481,19.9139629 21.2869434,19.9139629 C17.8191387,19.9139629 14.9979075,17.1109736 14.9979075,13.6655913 Z M42.4242424,15.041041 C42.32504,14.5675231 42.1717272,14.1087361 41.9910534,13.6775887 C40.7417755,13.0221354 38.4758639,11.8883044 35.7244872,10.7622186 C31.6234073,9.08394825 27.9301425,8.00843377 24.6916193,7.54159792 C32.0377952,7.08903746 39.784755,10.0387293 40.4926231,10.3155809 C40.2899383,9.83386219 40.0184692,9.3819092 39.7145949,8.96853015 C38.4511015,8.52872643 36.2955507,7.84897455 33.6789914,7.30802813 C30.8322336,6.71924394 27.0348751,6.23069126 23.3458903,6.66259795 C26.1050626,5.89278957 29.9218336,5.24629633 34.5478151,5.52147739 C34.1046905,5.09868265 33.5900302,4.75258021 33.0632944,4.47056519 C26.8007024,4.35074297 22.1903121,5.81321183 19.7802589,6.82463889 C21.5472542,5.42443506 24.6202363,3.51441733 29.3223392,2.25028537 C28.7350731,1.99454315 28.1065364,1.84131043 27.4949665,1.75459499 C22.0990581,3.48206988 18.9837353,5.98497219 17.431806,7.58472784 C18.6878095,5.22913548 20.565777,2.46441632 23.2963655,8.79616267e-05 C22.7430331,-0.00264562502 22.1962734,0.0585563427 21.6875744,0.152713216 C18.1005434,3.71032437 16.1189407,7.62390925 15.1137711,10.1688784 C15.292152,7.20415184 15.8676483,3.24698143 17.5253528,0.124314288 C17.0585359,0.233961486 16.6051701,0.396306159 16.1800824,0.595554253 C14.009399,5.41274139 13.9763825,11.439085 14.0505168,13.6570868 C12.915421,11.3727196 11.5126775,7.53582702 11.346372,2.30799442 C10.9912916,2.63374683 10.6745775,2.99503586 10.3956185,3.3625514 C10.7586474,9.16641145 12.5445966,13.148336 13.7139317,15.1780241 C8.15401072,10.0970458 5.96681905,5.86651677 5.848357,5.63218765 C5.66462617,6.05467865 5.52369454,6.49007826 5.41623799,6.91378419 C6.46374826,8.68287035 9.33756128,12.9446838 15.0604249,17.6701439 C11.0723043,15.8308957 8.15492784,13.8163942 6.27222187,12.2984943 C4.35252517,10.7508286 3.1760059,9.46710598 2.67051685,8.87391768 C2.58140281,9.32495948 2.54288354,9.78359457 2.53829791,10.2296248 C4.29031348,12.103954 8.5009899,15.96879 15.8153721,19.0988985 C8.43128835,17.5243526 1.01755084,13.5208631 3.19744231e-14,12.9589592 C0.0993552716,13.4323253 0.252515244,13.8911122 0.433188984,14.3222596 C1.68231403,14.9775611 3.94822564,16.1116958 6.69960239,17.2376298 C10.8008352,18.9159001 14.4942527,19.9914146 17.732776,20.4584023 C10.3859887,20.9108109 2.63765318,17.9605116 1.93146648,17.6839637 C2.13415123,18.1656824 2.40577326,18.6177873 2.70949468,19.0313182 C3.97298803,19.47097 6.12853886,20.1510257 8.74509815,20.6921239 C10.836603,21.1243344 13.4403226,21.5036954 16.1369775,21.5036954 C17.1209004,21.5036954 18.1168988,21.4488718 19.1052545,21.3322388 C16.3442479,22.105692 12.5178471,22.7568931 7.87673308,22.4788265 C8.31970474,22.9014694 8.83421219,23.24742 9.36094798,23.5295869 C9.60429197,23.5342947 9.84931736,23.5403694 10.0879229,23.5403694 C15.9825947,23.5403694 20.3262543,22.14867 22.6426078,21.1764244 C20.8753068,22.5766282 17.8027833,24.4860385 13.1017504,25.7498667 C13.6891693,26.0053052 14.3177061,26.1586898 14.9295817,26.2454052 C20.3257958,24.5177785 23.4412714,22.0145724 24.9925893,20.4148168 C23.7367387,22.770561 21.8587712,25.5355839 19.1278769,27.9999122 C19.6812093,28.0026458 20.2281219,27.941292 20.7368209,27.8471351 C24.3250747,24.2884609 26.3068303,20.3730536 27.3113885,17.8282363 C27.133619,20.7922036 26.5584284,24.7495259 24.8988896,27.8756859 C25.3657066,27.7660387 25.8189194,27.603694 26.2443129,27.4042941 C28.415302,22.5869551 28.4478599,16.5601559 28.3735728,14.3424578 C29.5088214,16.626825 30.9118707,20.4638695 31.0781761,25.6917021 C31.4332566,25.3659496 31.7498177,25.0046606 32.0287768,24.6372969 C31.665595,18.833285 29.8797987,14.8515123 28.7101579,12.8218243 C34.2673275,17.8999171 36.4552834,22.1290793 36.5758854,22.3676607 C36.759922,21.9451697 36.9005479,21.5097701 37.0081573,21.0860642 C35.9618698,19.3195597 33.0944767,15.0676176 27.3888856,10.3511175 C27.3864399,10.3465616 27.3833828,10.3424612 27.3807843,10.3379052 C31.3600394,12.1750273 34.2722188,14.1860359 36.1523263,15.7018097 C38.0718701,17.2491716 39.2482365,18.5325905 39.7537256,19.1262344 C39.8428396,18.6748889 39.8813589,18.2162538 39.8860974,17.7703754 C38.1339289,15.8958943 33.9230997,12.0310584 26.6085646,8.90079795 C33.9931069,10.4756476 41.4071502,14.479289 42.4242424,15.041041 Z"
          transform="translate(31.394)"
        />
        <path
          d="M19.2295446,22.2680347 L21.9464275,23.7597021 L21.9464275,23.9727546 L15.4541998,23.9727546 L15.4541998,20.8119261 C12.9138018,22.9783097 10.4792351,24.3990096 9.59725799,24.3990096 C5.32778542,24.3990096 2.71688288,22.090391 2.71688288,17.1184664 L2.71688288,1.70471988 L-1.77635684e-15,0.213202513 L-1.77635684e-15,-1.0658141e-14 L6.52755446,-1.0658141e-14 L6.52755446,16.1594302 C6.52755446,20.2081774 8.36231122,21.948456 11.0085405,21.948456 C12.9491286,21.948456 14.1487486,21.095946 15.4541998,19.9951249 L15.4541998,1.66931116 L15.4190221,1.70471988 L12.737317,0.213202513 L12.737317,-1.0658141e-14 L19.2295446,-1.0658141e-14 L19.2295446,22.2680347 Z"
          transform="translate(0 1.846)"
        />
      </svg>
    </EyeLogoWrapper>
  );
};

const Footer = () => (
  <Grid>
    <FooterWrapper>
      <Row middle="base" between="base">
        <Col sm={5} baseOrder={2} smOrder={'unset'}>
          <Copyright>
            <span>©{new Date().getFullYear()} Universal Patterns</span>
          </Copyright>
        </Col>

        <Col sm={2} baseOrder={1} smOrder={'unset'}>
          <Row center="xs">
            <Col>
              <EyeLogo />
            </Col>
          </Row>
        </Col>

        <Col base={false} sm={5}>
          <Row end="xs">
            <Col>
              <Button
                text="Get in touch"
                url="mailto:hello@universalpatterns.com"
                target="_blank"
                withArrow
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </FooterWrapper>
  </Grid>
);

export default Footer;
